/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiServicesDataTransferObjectsUserServiceCompleteExternalRegistrationDto
 */
export interface WebApiServicesDataTransferObjectsUserServiceCompleteExternalRegistrationDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCompleteExternalRegistrationDto
     */
    companyName: string;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsUserServiceCompleteExternalRegistrationDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsUserServiceCompleteExternalRegistrationDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "companyName" in value;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsUserServiceCompleteExternalRegistrationDtoFromJSON(json: any): WebApiServicesDataTransferObjectsUserServiceCompleteExternalRegistrationDto {
    return WebApiServicesDataTransferObjectsUserServiceCompleteExternalRegistrationDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsUserServiceCompleteExternalRegistrationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsUserServiceCompleteExternalRegistrationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyName': json['companyName'],
    };
}

export function WebApiServicesDataTransferObjectsUserServiceCompleteExternalRegistrationDtoToJSON(value?: WebApiServicesDataTransferObjectsUserServiceCompleteExternalRegistrationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyName': value.companyName,
    };
}

